import { RecommendCardContainer } from "./RecommendCard.styles";
import { RecommendedButton } from "shared/RecommendedButton/index";

const RecommendCard = () => {
  return (
    <>
      <RecommendCardContainer>
        <h2>Use AI to build your perfect portfolio </h2>
        <p>
          AI-Powered Portfolios tailored specifically for you based on your
          goals & preferences
        </p>
        <div className="button-wrapper">
          <RecommendedButton />
        </div>
      </RecommendCardContainer>
    </>
  );
};

export default RecommendCard;
